import { Observable } from 'rxjs'
import { UserProfileTrainingCertificate } from '../models/user-profile-training-certificate'
import { NextYearTrainingDetails } from '../models/next-year-training-details'

export abstract class UserProfileTrainingCertificateGateway {
    abstract getPendingTrainingCerificatesByOrgID(orgID: number): Observable<UserProfileTrainingCertificate[]>
    abstract showTrainingCerificate(userProfileTrainingCertificateID: number)
    abstract OpenPlanYears(): Observable<number[]>
    abstract addNextYearTrainingForUser(
        userProfileID: number,
        planyear1: number,
        planyear2: number,
        userProfileTrainingCertificateID: number
    ): Observable<NextYearTrainingDetails>
    abstract inValidTrainingCertificate(userProfileTrainingCertificateID: number): Observable<boolean>
}
